// import { mapKeys } from 'lodash';
import { types } from "../actionTypes";
const initialState = {
  getMasterHops: null,
  fetchId: "",
};
export default (state = initialState, action) => {
  switch (action.type) {
    // case types.FETCH_HOP_SUCCESS:
    //   // Copy the current state and set a new property with a dynamic key value and the payload as the value
    //   return { ...state, [action.payload.id]: action.payload };
    case types.FETCH_HOPS_SUCCESS:
      //   // Create a new state object that uses an AJAX request response and grabs the 'id' property from each object in the response to use as its key
      return action.payload;
    case types.FETCH_FILTER_HOPS_SUCCESS:
      state = {
        ...state,
        getMasterHops: action.payload,
        fetchId: "id" + new Date().getTime()
      };
      return state;
    case types.CREATE_HOP_SUCCESS:
      // Copy the current state and set a new property with a dynamic key value and the payload as the value
      return { ...state, [action.payload.id]: action.payload };
    case types.FETCH_SOURCE_DESTINATION:
      return { ...state };
    case types.DELETE_HOP_SUCCESS:
      // Copy the current state and delete the property with the specified key
      var newState = { ...state };
      delete newState[action.payload.id];
      return newState;
    default:
      state = { ...state };
      break;
  }
  //   case REGISTER_USER:
  //     state = {
  //         ...state,
  //         user: null,
  //         loading: true,
  //         registrationError: null
  //     }
  //     break;

  // case REGISTER_USER_SUCCESSFUL:
  //     state = {
  //         ...state,
  //         user: action.payload,
  //         loading: false,
  //         registrationError: null
  //     }
  //     break;
  // case REGISTER_USER_FAILED:
  //     state = {
  //         ...state,
  //         loading: false,
  //         registrationError: action.payload
  //     }
  //     break;
  return state;
};
